<template>
	<article class="image-result" @click="show" :data-id="page.type + '-' + page.id">
	  <div class="db db--outer">
        <div class="aspect-ratio aspect-ratio--3x4">
            <div v-lazyload class="image-result-img db contain aspect-ratio--object">
            	<div class="image-placeholder">
				    <h5>{{page.page + 1}}</h5>
				</div>
                <img class="card-img-top image-result-img-item" :data-url="page.iiif_root + '/full/400,/0/default.jpg'" @load="loaded = true">
                <template v-if="previewAnnotations && page.annotations.length > 0 && loaded">
			    	<div v-for="annotation in page.annotations" :key="annotation.id" class="region" :id="'annotation' + annotation.id" v-position="{origImageWidth: page.width, origImageHeight: page.height, annotation: annotation}" />
			    </template>
            </div>
        </div>
		<h3 class="image-title mt-3">{{page.document.formatted_from_date}} - {{page.document.formatted_to_date}}</h3>
		<h3 class="image-detail mt-1 d-flex justify-content-between">
			<div>{{ __('translations.page')}} {{page.page + 1}}</div>
			<div><i class="far fa-object-ungroup ml-2 mr-1"></i>&nbsp;<span id="annotations_count">{{page.annotations.length}}</span></div>
		</h3>
      </div>
    </article>
</template>

<script>
import {mapGetters} from 'vuex'
import PageModal from '../components/PageModal'
import LazyLoadDirective from '../directives/LazyLoadDirective';
import AnnotationPositionDirective from '../directives/AnnotationPositionDirective';

export default {
	name: "PageResult",
	directives: {
		lazyload: LazyLoadDirective,
		position: AnnotationPositionDirective
	},
	props: ['page'],
	data() {
		return {
			loaded: false
		}
	},
	computed: {
		...mapGetters([
			'previewAnnotations'
		])
	},
	methods: {
		show () {
			this.$store.dispatch('GET_PAGE', {'id': this.page.id}).then((response) => {
				this.$modal.hideAll(); // To prevent from opening multiple modals
				this.$modal.show(PageModal, {}, {width: '100%', height: '100%'});
			});
		}
	}
}
</script>